import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cajasocial/marca.svg'
import _imports_1 from '@/assets/cajasocial/logobank.png'
import _imports_2 from '@/assets/iris/listo.svg'


const _hoisted_1 = { class: "lg:container mx-auto border my-2 rounded w-full bg-white shadow-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute mt-12 hidden lg:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full ml-3",
    src: _imports_0,
    alt: "vigiladocajasocial"
  })
], -1)
const _hoisted_3 = { class: "lg:px-12 lg:py-8" }
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex lg:justify-between justify-around pb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-44 lg:w-96",
    src: _imports_1,
    alt: "logo_caja_social"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-32 lg:w-72 lg:flex",
    src: _imports_2,
    alt: "logo_listo"
  })
], -1)
const _hoisted_6 = { class: "flex flex-col lg:flex-row justify-between mx-2" }
const _hoisted_7 = { class: "pb-3" }
const _hoisted_8 = { class: "text-sm lg:text-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Señor(a): ", -1)
const _hoisted_10 = { class: "text-sm lg:text-lg" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Compra en: ", -1)
const _hoisted_12 = { class: "pb-3" }
const _hoisted_13 = { class: "text-sm lg:text-lg" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Referencia de pago: ", -1)
const _hoisted_15 = { class: "text-sm lg:text-lg" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Número de crédito: ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-justify mb-4 px-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Información importante:"),
  /*#__PURE__*/_createTextVNode(" 1.Banco Caja Social NIT. 860.007.335-4 informa que la Defensoría del Cliente es ejercida por los Doctores José Guillermo Peña González (Defensor Principal) y Carlos Alfonso Cifuentes Neira (Defensor Suplente).Dirección: Av. 19 No. 114-09 Oficina 502, Bogotá D.C. Teléfonos 2131322 - 2131370. E-Mail: defensorbancocajasocial@pgabogados.com. Horario de atención de Lunes a viernes de 8:30 a.m. a 1:00 p.m. y de 2:00 p.m. a 5:30 p.m.2.Por favor informar su inconformidad sobre el contenido del extracto a nuestros revisores fiscales Deloitte & Touche Ltda., al correo revisoriafiscalbanco@fs.co o al A.A. No. 075874 de Bogotá. ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-borderTwo" }, null, -1)
const _hoisted_19 = { class: "w-full flex flex-col lg:flex-row items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-2/6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_1,
    alt: "logo_caja_social"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "w-full lg:w-1/4 text-sm p-3 text-justify print:text-xs" }, " Cuando se acerque a las sucursales del banco, indique el número del convenio y su documento de identidad como referencia. ", -1)
const _hoisted_22 = { class: "flex flex-col gap-2 w-full lg:w-2/4 p-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between bg-grisTwo p-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Numero de convenio:"),
  /*#__PURE__*/_createElementVNode("span", null, "15891981")
], -1)
const _hoisted_24 = { class: "flex justify-between bg-grisTwo p-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Referencia de pago:", -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded-md px-4 my-2\"><p class=\"text-xs lg:text-md text-justify\"> Estimado cliente, si su obligación financiera presenta días de mora, se podrán generar <span class=\"font-bold\">cargos por cobranza entre el 4% y 20% de acuerdo con la altura de mora</span> calculados sobre los conceptos no pagados. En caso de requerir información adicional para realizar su pago, por favor comunicarse con nuestra Línea de Servicio al Cliente <span class=\"font-bold\">601 744 2333</span> en Bogotá o <span class=\"font-bold\">01 8000 111 280 </span> a nivel nacional. </p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentDetail = _resolveComponent("PaymentDetail")!
  const _component_Channels = _resolveComponent("Channels")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.data.nombre_cliente), 1)
            ]),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.data.nombre_comercio), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.data.referencia_pago_2), 1)
            ]),
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.data.numero_obligacion), 1)
            ])
          ])
        ])
      ]),
      _createVNode(_component_PaymentDetail, { data: _ctx.data }, null, 8, ["data"]),
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", null, _toDisplayString(_ctx.data.referencia_pago_2), 1)
          ])
        ])
      ]),
      _createVNode(_component_Channels),
      _hoisted_26
    ]),
    _createVNode(_component_Footer)
  ]))
}